import { WhatsappConversationDto } from "./WhatsappConversationDto";
import { WhatsappConversationModel } from "./WhatsappConversationModel";

export const transformWhatsappConversationDtoToModel = (
  dto: WhatsappConversationDto
): WhatsappConversationModel => dto;
